// src/store/api/providerApi.js

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ProviderAvailabilityApi = createApi({
  reducerPath: "ProviderAvailabilityApi",

  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API}users/available`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().userSlice?.token;

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),

  tagTypes: ["Availability"],

  endpoints: (builder) => ({
    getProviderAvailability: builder.query({
      query: (id) => `/provider/${id}`,

      providesTags: (result, error, id) => [
        { type: "Availability", id },
      ],
    }),

    updateAvailability: builder.mutation({
      query: ({ id, weeklySchedule, description }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: {
          weeklySchedule,
          description,
        },
      }),

      invalidatesTags: (result, error, { id }) => [
        { type: "Availability", id },
      ],
    }),
  }),
});

export const {
  useGetProviderAvailabilityQuery,
  useUpdateAvailabilityMutation,
} = ProviderAvailabilityApi;